module.exports = __webpack_public_path__ + "img/labvida.7fb499b4.jpg";